import { useCallback } from 'react';

import { useInspoImport } from '@/contexts/InspoImportContext';

interface OpenInspoImportOptions {
  url?: string;
}

/**
 * Opens the global Inspo Import modal without changing the current route.
 */
export function useOpenInspoImportRoute() {
  const { openInspoImport } = useInspoImport();

  return useCallback(
    (options: OpenInspoImportOptions = {}) => {
      openInspoImport({
        prefilledUrl: options.url,
        entry: 'in_app',
      });
    },
    [openInspoImport],
  );
}
